import type { Locale } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * `parsePayloadDate` anchors the payload wall clock to UTC, so reading it back
 * has to happen in the same zone.
 */
export const PAYLOAD_TIME_ZONE = 'UTC';

type PayloadDateOptions = {
  locale?: Locale;
};

export function formatPayloadDate(
  date: Date,
  formatString: string,
  { locale }: PayloadDateOptions = {},
): string {
  return formatInTimeZone(date, PAYLOAD_TIME_ZONE, formatString, { locale });
}

export function getPayloadDayOfWeek(date: Date): number {
  return date.getUTCDay();
}

/**
 * `date-fns/addDays` advances the shopper's local calendar day, which is 23 or
 * 25 hours across a daylight saving transition and would move the UTC anchor to
 * another day than intended, so the anchor counts whole UTC days instead.
 */
export function addPayloadDays(date: Date, amount: number): Date {
  const shiftedDate = new Date(date.getTime());
  shiftedDate.setUTCDate(shiftedDate.getUTCDate() + amount);

  return shiftedDate;
}
